'use client';

import * as React from 'react';
import { useEnhancedEffect } from './useEnhancedEffect.js';
import { warn } from './warn.js';
/**
 * Use this function determine the host element correctly on the server (in a SSR context, for example Next.js)
 */
export function useRootElementName(parameters) {
  const {
    rootElementName: rootElementNameProp = ''
  } = parameters;
  const [rootElementName, setRootElementName] = React.useState(rootElementNameProp.toUpperCase());
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEnhancedEffect(() => {
      if (rootElementNameProp && rootElementName !== rootElementNameProp.toUpperCase()) {
        warn(`useRootElementName expected the '${rootElementNameProp}' element, but a '${rootElementName.toLowerCase()}' was rendered instead`, 'This may cause hydration issues in an SSR context, for example in a Next.js app');
      }
    }, [rootElementNameProp, rootElementName]);
  }
  const updateRootElementName = React.useCallback(element => {
    setRootElementName(element?.tagName ?? '');
  }, []);
  return {
    rootElementName,
    updateRootElementName
  };
}